import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getSingleCityFunc = createAsyncThunk(
    "getSingleCity",
    async (id, thunkAPI) => {
        try {
            const response = await axios.get(`dashboard/cities/${id}`);
            return response.data.data.city;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
        
    }
)

const getSingleCitySlicer = createSlice({
    name : "getSingleCity",
    initialState : {
        loading : null,
        data : null,
        error : null
    },
    reducer : {},
    extraReducers : (builder) => {
        builder.addCase(getSingleCityFunc.pending , (state) => {
            state.loading = true
            state.data = null
            state.error = null
        })
        builder.addCase(getSingleCityFunc.rejected , (state) => {
            state.loading = null
            state.data = null
            state.error = true
        })
        builder.addCase(getSingleCityFunc.fulfilled , (state , action) => {
            state.loading = false
            state.data = action.payload
            state.error = null
        })
    }
})

export default getSingleCitySlicer.reducer;